<!-- <template>
  <div>
    <Bar
      id="my-chart-id"
      v-if="loaded" 
      :options="chartOptions"
      :data="chartData"
    />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
import DataService from '@/services/data.service';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
  name: 'BarChart',
  components: { Bar },
  props: {
    range: {
      type: String,
      required: false
    },
    labels: {
      type: Array,
      required: false
    },
    data: {
      type: Array,
      required: false
    },
    unit: {
      type: String,
      required: false
    },
    colours: {
      type: Array,
      required: false
    }
  },
  data() {
    const that = this;
    return {
      chartData: {
        labels: this.labels || [
  "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00",
  "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00"
]
        ,
        datasets: [
          {
            data: Array(17).fill(0),
            backgroundColor: this.colours || '#453A94',
            borderRadius: 7, 
          }
        ],
      },
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                return context.raw + (that.unit || ' kWh');
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            min: 0,
            // max: 2,
            ticks: {
              stepSize: 0.2,
              font: {
                size: 9    // Adjust the size as needed
              },
              callback: function(value) {
                if (value === 0) return '0';
                return value + (that.unit ||' ');
              }
            }
          },
          x: {
            grid: {
              display: false
            },
            ticks: {
              autoSkip: true,
              maxRotation: 0,
              minRotation: 0,
              fontSize: 5,
              font: {
                size: 10    // Adjust the size as needed
              },
              // gap: 20,
              maxTicksLimit: 10
            }
          }
        },
        layout: {
          padding: {
            top: 0,
            bottom: 0
          }
        },
        barPercentage: 0.5,
        categoryPercentage: 0.8
      },
      today:new Date().toISOString().slice(0, 10),
      newData:null,
      loaded: false,
      imei: '',
    }
  },
  async mounted() {
  try {
    await this.extractImei();
    console.log(this.imei,"logging imei in barchart")
    const result= await DataService.getDataForDateRange(this.changeDateString(this.today), this.changeDateString(this.today),this.imei);
    this.newData = this.data ? this.data : result.todayGraph;
    this.chartData.datasets[0].data = this.newData;
    this.loaded = true;
    window.addEventListener('resize', this.adjustBarPercentage);
  } catch (error) {
    console.error('Error loading chart data:', error);
  }
},

  methods: {
    adjustBarPercentage() {
      // if (window.innerWidth < 600) {
      //   this.chartOptions.barPercentage = 0.3;
      //   this.chartOptions.categoryPercentage = 0.6;
      //   this.chartOptions.scales.x.ticks.fontSize = 5;
      // } else {
      //   this.chartOptions.barPercentage = 0.5;
      //   this.chartOptions.categoryPercentage = 0.8;
      //   this.chartOptions.scales.x.ticks.fontSize = 5;
      // }
    },
    changeDateString(date) {
      return date.split('-').reverse().join('');
    },
    async extractImei() {
      const data = this.$store.getters.currentUserNode;
      if (data && data.hardwareGroups) {
       const imei= data.hardwareGroups[0].devices[0].props.find((el) => el.prop === "imei")?.val || "";
       if(imei){
        this.imei = imei;
        return;
       }
       this.imei='';      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustBarPercentage);
  }
}
</script>

<style scoped>
p {
  margin-top: 40px;
  font-size: 12px;
  font-family: "Montserrat", sans-serif;
}
</style>  -->


<template>
  <div :class="{ 'dark-mode': isDarkMode }">
    <Line
      id="my-chart-id"
      v-if="loaded"
      :options="chartOptions"
      :data="chartData"
      :labels="labels"
    />
  </div>
</template>

<script>
import { Line } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, BarElement, PointElement, CategoryScale, LinearScale } from 'chart.js';
import DataService from '@/services/data.service';

ChartJS.register(Title, Tooltip, Legend, LineElement, BarElement, PointElement, CategoryScale, LinearScale);

export default {
  name: 'BarChart',
  components: { Line },
  props: {
    range: {
      type: String,
      required: false
    },
    labels: {
      type: Array,
      required: false
    },
    data: {
      type: Array,
      required: false
    },
    unit: {
      type: String,
      required: false
    },
    colours: {
      type: Array,
      required: false
    }
  },
  data() {
    const that = this;
    return {
      isDarkMode: false,
      chartData: {
        labels: this.labels || ["05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00",
        "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00"],
        datasets: [
          {
            type: 'bar',
            label: 'Energy',
            data: [],
            backgroundColor: this.isDarkMode ? '#00F2B2' : '#453A94',
            borderColor: this.isDarkMode ? '#00F2B2' : '#453A94',
            borderWidth: 1,
            barThickness: 5,
            maxBarThickness: 15,
            categoryPercentage: 0.8,
            barPercentage: 0.9,
          },
          {
            type: 'line',
            label: 'Power',
            data: [],
            backgroundColor: function(context) {
              const chart = context.chart;
              const {ctx, chartArea} = chart;
              if (!chartArea) {
                return null;
              }
              const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
              if (that.isDarkMode) {
                gradient.addColorStop(0, 'rgba(0, 242, 178, 0.1)');
                gradient.addColorStop(1, 'rgba(0, 242, 178, 0.5)');
              } else {
                gradient.addColorStop(0, 'rgba(69, 58, 148, 0.1)');
                gradient.addColorStop(1, 'rgba(69, 58, 148, 0.5)');
              }
              return gradient;
            },
            borderColor: this.isDarkMode ? '#00F2B2' : '#453A94',
            borderWidth: 2,
            tension: 0.4,
            pointRadius: 1,
            fill: true,
          }
        ],
      },
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                return context.raw;
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            min: 0,
            max: 5,
            ticks: {
              stepSize: 1,
              font: {
                size: 9,
                color: this.isDarkMode ? 'white' : 'black', 
              },
              callback: function(value) {
                if (value === 0) return '0';
                return value;
              }
            }
          },
          x: {
            grid: {
              display: false,
            },
            ticks: {
              autoSkip: true,
              maxRotation: 0,
              minRotation: 0,
              font: {
                size: 9,
                color: this.isDarkMode ? 'white' : 'black', 
              },
              maxTicksLimit: 10
            }
          }
        },
        layout: {
          padding: {
            top: 0,
            bottom: 0
          }
        }
      },
      today: new Date().toISOString().slice(0, 10),
      newPowerData: null,
      newEnergyData: null,
      loaded: false,
      imei: '',
    }
  },
  async mounted() {
    const savedDarkMode = localStorage.getItem('darkMode');
    if (savedDarkMode === 'true') {
      this.isDarkMode = true;
    }
    try {
      await this.extractImei();
      const result = await DataService.getDataForDateRange(this.changeDateString(this.today), this.changeDateString(this.today), this.imei);
      this.newPowerData = result.todayPowerGraph;
      this.newEnergyData = result.todayGraph;

      this.chartData.datasets[0].data = this.newEnergyData; 
      // this.chartData.datasets[1].data = this.newPowerData; 

      this.loaded = true;
      window.addEventListener('resize', this.adjustBarPercentage);
    } catch (error) {
      console.error('Error loading chart data:', error);
    }
  },
  methods: {
    adjustBarPercentage() {
      // This method can be removed or adjusted as needed for the line chart
    },
    changeDateString(date) {
      return date.split('-').reverse().join('');
    },
    async extractImei() {
      const data = this.$store.getters.currentUserNode;
      if (data && data.hardwareGroups) {
        const imei = data.hardwareGroups[0].devices[0].props.find((el) => el.prop === "imei")?.val || "";
        if (imei) {
          this.imei = imei;
          return;
        }
        this.imei = '';
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustBarPercentage);
  },
  watch: {
    isDarkMode(newVal) {
      this.chartData.datasets[0].backgroundColor = newVal ? '#00F2B2' : '#453A94';
      this.chartData.datasets[0].borderColor = newVal ? '#00F2B2' : '#453A94';
      this.chartData.datasets[1].borderColor = newVal ? '#00F2B2' : '#453A94';
      this.chartOptions.scales.y.ticks.font.color = newVal ? 'white' : 'black';
      this.chartOptions.scales.x.ticks.font.color = newVal ? 'white' : 'black';
    }
  }
}
</script>

<style scoped>

p {
  margin-top: 40px;
  font-size: 12px;
  font-family: "Montserrat", sans-serif;
}

.dark-mode {
  color: white;
}
</style>


